(function(){
    'use strict';

    angular
        .module('elogbooks.admin.sites')
        .controller('SiteDetailsController', SiteDetailsController);

    SiteDetailsController.$inject = [
        'siteResponse',
        'approversResponse',
        'quoteThresholdsCollectionResponse',
        'userManager',
        'modulesService'
    ];

    function SiteDetailsController (
        siteResponse,
        approversResponse,
        quoteThresholdsCollectionResponse,
        userManager,
        modulesService
    ) {
        var vm = this;
        vm.site = siteResponse.getData();
        vm.isClientAdmin = userManager.hasPermission('user_permission_client_admin_manage_sites') && !userManager.hasPermission('user_permission_view_sites');
        vm.canAccessPartnerships = userManager.hasPermission('site_permission_view_partnerships') || userManager.hasPermission('user_permission_client_admin_edit_partnerships');

        vm.quoteThresholdsCollection = quoteThresholdsCollectionResponse.quoteThresholds;
        vm.approvers = approversResponse;
        vm.canAccessPartnerships = userManager.hasPermission('site_permission_view_partnerships') || userManager.hasPermission('user_permission_client_admin_edit_partnerships');
        vm.contractsModuleEnabled = modulesService.isEnabled('contracts_module');
        vm.tasksModuleEnabled = modulesService.isEnabled('tasks_module');
        vm.quotesModuleEnabled = modulesService.isEnabled('quotes');
        vm.approverNames = {
            reactiveJobApprovers: 'REACTIVE_JOB_APPROVERS',
            reactiveJobExtensionsApprovers: 'REACTIVE_JOB_EXTENSIONS_APPROVERS',
            ...(vm.tasksModuleEnabled && {
                plannedJobApprovers: 'PLANNED_JOB_APPROVERS',
                plannedJobExtensionsApprovers: 'PLANNED_JOB_EXTENSIONS_APPROVERS'
            }),
            quoteApprovers: 'QUOTE_APPROVERS',
            contractApprovers: 'CONTRACT_APPROVERS',
            surveyApprovers: 'SURVEY_APPROVERS'
        };
    }
})();

